import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default class AccountService {
    static accountExists(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayaccountAccount'),
            'accountExists', [accountNumber], additionalHeaders);
    }
}
